import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./menuToggle.css";

const EkoBillingNavbar = () => {
  const [mobileExpanded, setMobileExpanded] = useState<boolean>();
  const path = useLocation().pathname;
  let active = (dir: string) => {
    return path === "/" + dir ? true : false;
  };

  const handleChange = (e: any) => {
    let isChecked = e.target.checked;
    console.log(isChecked, "xdd");
    setMobileExpanded(isChecked);
  };

  return (
    <>
      <div id="menuToggle">
        <input type="checkbox" onChange={(e) => handleChange(e)} />
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div
        className={mobileExpanded ? "container-nav expanded" : "container-nav"}
      >
        <nav className="navbar navbar-expand-lg mainNavbar">
          <div className="collapse navbar-collapse container " id="navbarNav">
            <ul className="navbar-nav  pull-sm-left ">
              <li className="nav-item ">
                <Link
                  to="/"
                  className={
                    active("")
                      ? "nav-link mainNavItem mainActive"
                      : "nav-link mainNavItem"
                  }
                >
                  Pulpit
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  to="/Agreements"
                  className={
                    active("Agreements")
                      ? "nav-link mainNavItem mainActive"
                      : "nav-link mainNavItem"
                  }
                >
                  Umowy
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/Invoices"
                  className={
                    active("Invoices")
                      ? "nav-link mainNavItem mainActive"
                      : "nav-link mainNavItem"
                  }
                >
                  Faktury
                </Link>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </>
  );
};

export { EkoBillingNavbar };
